/* RIPP brand mark — the exact R from the Core render / coin (alpha mask), tinted with currentColor. */
export const RippMark = ({ size = 28, className = "", glow = false, testid = "ripp-mark" }) => (
  <span
    role="img" aria-label="RIPP" data-testid={testid} className={`inline-block shrink-0 ${className}`}
    style={{
      width: size, height: size, backgroundColor: "currentColor",
      WebkitMaskImage: "url(/ripp-r-white.png)", maskImage: "url(/ripp-r-white.png)",
      WebkitMaskSize: "contain", maskSize: "contain", WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskPosition: "center", maskPosition: "center",
      filter: glow ? "drop-shadow(0 0 6px rgba(56,189,248,0.7))" : undefined,
    }}
  />
);
